import React from "react";
import { useNavigate } from "react-router-dom";
import "./Story.css";
import "./contentpage.css";

function ForewordBitcoinTech() {
  const navigate = useNavigate();

  const handleBegin = () => {
    navigate("/bitcoin-tech-page-71"); //
  };
  return (
    <div className="story-page">
      <div className="story-container">
        بسم الله الرحمن الرحيم
        <h1 className="story-title">Curators Foreword</h1>
        <h3>Fundamentals of Bitcoin Tech</h3>
        <p className="story-text">
          <p className="story-text">
            At its core, Bitcoin is a piece of software that functions as money.
            While it is not necessary for every user to understand the deepest
            technical details of Bitcoin, having an intermediate level of
            technical understanding enables more informed decision-making and
            allows individuals to become active and responsible participants in
            the network.
            <br />
            <br />
            Unlike traditional financial systems, Bitcoin operates without a
            central authority. Its rules, upgrades, and evolution are ultimately
            determined by its users. This makes an understanding of Bitcoin’s
            technical foundations not merely optional, but empowering. Knowledge
            of how the system works strengthens sovereignty, responsibility, and
            informed participation.
            <br />
            <br />
            This section explores the fundamental technical primitives of
            Bitcoin and provides the learner with the essential tools needed to
            understand how the network functions. By doing so, it aims to
            demystify what is arguably one of the most disruptive technological
            innovations of our time, without overwhelming the learner with
            unnecessary complexity.
            <br />
            <br />
            Through this section, the learner will gain clarity, confidence, and
            a grounded understanding of Bitcoin as a technological system,
            enabling them to engage with it thoughtfully and responsibly.
            <br />
            <br /> The learner receives a badge at both the beginning and the
            completion of this section. The term “graduate” is purely figurative
            and is used only to congratulate the learner and gamify the learning
            process.
            <br />
            <br />
            Each lesson includes a dashboard with a timer, a summary paragraph,
            and four MCQs to test understanding.
            <br />
            <br />
            The ideal pace is one lesson per day, though learners may adjust
            according to their capacity.
          </p>
        </p>
        {/* BUTTON */}
        <button className="popup-close-btn" onClick={handleBegin}>
          Let us begin!
        </button>
      </div>
    </div>
  );
}

export default ForewordBitcoinTech;
